import React, { useEffect, useState } from 'react';
import { loginSSO } from '../services/auth.service';

type GoogleSignInProps = {
  setErrors: (errors: string[]) => void;
};
interface GoogleResponse {
  credential: string;
}

const GoogleSignIn: React.FC<GoogleSignInProps> = ({ setErrors }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (
      !window.google?.accounts ||
      !loaded ||
      process.env.REACT_APP_ALLOW_GOOGLE_SSO !== 'true'
    ) {
      return;
    }
    // Initialize Google Identity Services
    window.google.accounts.id.initialize({
      client_id: `${process.env.REACT_APP_GOOGLE_CLIENT_ID}`,
      callback: handleCredentialResponse
    });

    const button = document.getElementById('google-signin-button');

    // Render the Google Sign-In button
    window.google.accounts.id.renderButton(
      button,
      { theme: 'outline', size: 'large' } // Customize button as needed
    );
  }, [loaded]);

  useEffect(() => {
    if (process.env.REACT_APP_ALLOW_GOOGLE_SSO !== 'true') {
      return;
    }
    const scriptTag = document.createElement('script');
    scriptTag.src = 'https://accounts.google.com/gsi/client';
    scriptTag.addEventListener('load', () => setLoaded(true));
    document.body.appendChild(scriptTag);
  }, []);

  const handleCredentialResponse = (response: GoogleResponse) => {
    // Handle the Google ID token
    const idToken = response.credential;
    // Send this ID token to your backend
    authenticateWithBackend(idToken);
  };

  const authenticateWithBackend = async (idToken: string) => {
    try {
      const response = await loginSSO(idToken, false);
      if (response.success) {
        window.location.href = '/';
      } else {
        setErrors(response.errors);
      }
    } catch (error) {
      console.error('Error logging in:', error);
      setErrors(['There was a problem logging in']);
    }
  };

  if (process.env.REACT_APP_ALLOW_GOOGLE_SSO !== 'true') {
    return null;
  }
  return (
    <div>
      {loaded && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div id="google-signin-button"></div>
        </div>
      )}
    </div>
  );
};

export default GoogleSignIn;
